<!--
    If using parameters, add them as &_parm in the URL. 
    For each &_parm in the url, they will be replaced one by one by values passed in the parms prop
-->

<template>
<router-link :to="dynamicLink">
    <slot></slot>
</router-link>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            default: 'javascript:void(0)',
            required: true
        },
        parms: {
            type: Array,
            required: false
        }
    },
    computed: {
        dynamicLink() {
            let url = this.url;
            if (this.url != 'javascript:void(0)') {
                for (var x = 0; x < this.parms.length; x++) {
                    url = url.replace("&_parm", this.parms[x]);
                }
            }

            return url;
        }
    }
}
</script>